import { render, staticRenderFns } from "./uploadVideo.vue?vue&type=template&id=4b486c26&scoped=true&"
import script from "./uploadVideo.vue?vue&type=script&lang=js&"
export * from "./uploadVideo.vue?vue&type=script&lang=js&"
import style0 from "./uploadVideo.vue?vue&type=style&index=0&id=4b486c26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b486c26",
  null
  
)

export default component.exports